module.exports = __webpack_public_path__ + "static/PostGrotesk-Bold-e743c42b754759498a473ad108671fe7.svg";